import covidForIndividualsImage from "../../assets/images/covid-for-individuals.jpg";
import covidForOrganizationsImage from "../../assets/images/covid-for-organizations.jpg";
import membershipCurrentImage from "../../assets/images/membership-current.jpg";
import membershipControlImage from "../../assets/images/membership-control.jpg";
import membershipControlPromoImage from "../../assets/images/membership-control-promo.jpg";
import membershipCurrentPromoImage from "../../assets/images/membership-current-promo.jpg";
export var Tag;
!function (e) {
  e.General = "general", e.Men = "men", e.Women = "women", e.EnergyWeight = "energy-weight", e.SexualHealth = "sexual-health", e.COVID = "covid", e.Memberships = "memberships", e.None = "";
}(Tag || (Tag = {}));
export var productCategories = [{
  displayName: "General Wellness",
  slug: Tag.General
}, {
  displayName: "Men's Health",
  slug: Tag.Men
}, {
  displayName: "Women's Health",
  slug: Tag.Women
}, {
  displayName: "Energy + Weight",
  slug: Tag.EnergyWeight
}, {
  displayName: "Sexual Health",
  slug: Tag.SexualHealth
}, {
  displayName: "COVID-19",
  slug: Tag.COVID
}, {
  displayName: "Memberships",
  slug: Tag.Memberships
}];
export var productLinks = [{
  slug: "food-sensitivity-test",
  label: "Food Sensitivity Test",
  url: "/products/food-sensitivity/",
  tags: [Tag.General]
}, {
  slug: "food-sensitivity-comprehensive-test",
  label: "Food Sensitivity Comprehensive Test",
  url: "/products/food-sensitivity-comprehensive-test/",
  tags: [Tag.General]
}, {
  slug: "b-vitamins-test",
  label: "B Vitamins Test",
  url: "/products/b-vitamins-test/",
  tags: [Tag.General]
}, {
  slug: "fit-colon-cancer-screening-test",
  label: "FIT Colon Cancer Screening Test",
  url: "/products/fit-colon-cancer-screening-test/",
  tags: [Tag.General]
}, {
  slug: "folic-acid-test",
  label: "Folic Acid Test",
  url: "/products/folic-acid-test/",
  tags: [Tag.General]
}, {
  slug: "lyme-disease-test",
  label: "Lyme Disease Test",
  url: "/products/lyme-disease-test/",
  tags: [Tag.General]
}, {
  slug: "indoor-outdoor-allergy-test",
  label: "Indoor & Outdoor Allergy Test",
  url: "/products/indoor-outdoor-allergy-test/",
  tags: [Tag.General]
}, {
  slug: "covid-19-test",
  label: "COVID-19 Test Home Collection Kit",
  url: "/products/covid-19-test/",
  tags: [Tag.General]
}, {
  slug: "cholesterol-and-lipids-test",
  label: "Cholesterol and Lipids Test",
  url: "/products/cholesterol-and-lipids-test/",
  tags: [Tag.General]
}, {
  slug: "heart-health-test",
  label: "Heart Health Test",
  url: "/products/heart-health-test/",
  tags: [Tag.General]
}, {
  slug: "hba1c-test",
  label: "HbA1c Test",
  url: "/products/hba1c/",
  tags: [Tag.General]
}, {
  slug: "sleep-and-stress-panel",
  label: "Sleep and Stress Test",
  url: "/products/sleep-and-stress-panel/",
  tags: [Tag.General]
}, {
  slug: "elements-panel",
  label: "Heavy Metals Test",
  url: "/products/elements-panel/",
  tags: [Tag.General]
}, {
  slug: "testosterone-test",
  label: "Testosterone Test",
  url: "/products/testosterone-test/",
  tags: [Tag.Men]
}, {
  slug: "mens-health-test",
  label: "Men's Health Test",
  url: "/products/mens-health-test/",
  tags: [Tag.Men]
}, {
  slug: "hpv-test-female",
  label: "HPV Test - Female",
  url: "/products/hpv-test-female/",
  tags: [Tag.Women]
}, {
  slug: "womens-health-test",
  label: "Women's Health Test",
  url: "/products/womens-health-test/",
  tags: [Tag.Women]
}, {
  slug: "ovarian-reserve-test",
  label: "Ovarian Reserve Test",
  url: "/products/ovarian-reserve-test/",
  tags: [Tag.Women]
}, {
  slug: "perimenopause-test",
  label: "Perimenopause Test",
  url: "/products/perimenopause-test/",
  tags: [Tag.Women]
}, {
  slug: "postmenopause-test",
  label: "Postmenopause Test",
  url: "/products/postmenopause-test/",
  tags: [Tag.Women]
}, {
  slug: "womens-fertility-test",
  label: "Women's Fertility Test",
  url: "/products/womens-fertility-test/",
  tags: [Tag.Women]
}, {
  slug: "thyroid-test",
  label: "Thyroid Test",
  url: "/products/thyroid-test/",
  tags: [Tag.EnergyWeight]
}, {
  slug: "vitamin-d-test",
  label: "Vitamin D Test",
  url: "/products/vitamin-d-test/",
  tags: [Tag.EnergyWeight]
}, {
  slug: "metabolism-test",
  label: "Metabolism Test",
  url: "/products/metabolism/",
  tags: [Tag.EnergyWeight]
}, {
  slug: "vitamin-d-and-inflammation-test",
  label: "Vitamin D and Inflammation Test",
  url: "/products/vitamin-d-and-inflammation-test/",
  tags: [Tag.EnergyWeight]
}, {
  slug: "trichomoniasis-test",
  label: "Trichomoniasis Test",
  url: "/products/trichomoniasis-test/",
  tags: [Tag.SexualHealth]
}, {
  slug: "chlamydia-gonorrhea-test",
  label: "Chlamydia and Gonorrhea Test",
  url: "/products/chlamydia-gonorrhea-test/",
  tags: [Tag.SexualHealth]
}, {
  slug: "hepatitis-c-test",
  label: "Hepatitis C Test",
  url: "/products/hepatitis-c-test/",
  tags: [Tag.SexualHealth]
}, {
  slug: "syphilis-test",
  label: "Syphilis Test",
  url: "/products/syphilis-test/",
  tags: [Tag.SexualHealth]
}, {
  slug: "hiv-test",
  label: "HIV Test",
  url: "/products/hiv-test/",
  tags: [Tag.SexualHealth]
}, {
  slug: "std-test-female",
  label: "STD Test - Female",
  url: "/products/std-test-female/",
  tags: [Tag.SexualHealth]
}, {
  slug: "std-test-male",
  label: "STD Test - Male",
  url: "/products/std-test-male/",
  tags: [Tag.SexualHealth]
}];
export var productCards = [{
  slug: "control-membership",
  label: "Control –\nProactive Health",
  url: "/control-membership/",
  tags: [Tag.Memberships],
  description: "Choose from 14 different health tests and save 50%+ every month.",
  image: {
    alt: "Control — Proactive Health Membership",
    src: membershipControlImage
  },
  cta: "Become a member",
  "data-analytics-event": "Clicked Button",
  "data-analytics-label": "navigation-link-control-membership"
}, {
  slug: "current-membership",
  label: "Current –\nSexual Health",
  url: "/current-membership/",
  tags: [Tag.Memberships],
  description: "Choose from 5 different STI tests and save up to 70% every month.",
  image: {
    alt: "Current – Sexual Health Membership",
    src: membershipCurrentImage
  },
  cta: "Become a member",
  "data-analytics-event": "Clicked Button",
  "data-analytics-label": "navigation-link-current-membership"
}, {
  slug: "individual-covid-19-test",
  label: "For\nIndividuals",
  url: "/products/covid-19-test/",
  tags: [Tag.COVID],
  description: "<strong>Now available, COVID-19 Test Home Collection Kit</strong><br/>Collect your sample from home and send it to a certified lab for secure digital results.",
  image: {
    alt: "Covid-19 Tests For Individuals",
    src: covidForIndividualsImage
  },
  cta: "Learn More"
}, {
  slug: "business-covid-19",
  label: "For\nOrganizations",
  url: "/business/covid-19",
  tags: [Tag.COVID],
  description: "<strong>COVID-19 testing for qualifying organizations</strong><br />Qualifying organizations can request bulk orders of collection kits for their patients or employees.",
  image: {
    alt: "Covid-19 Tests For Organizations",
    src: covidForOrganizationsImage
  },
  cta: "Request Bulk Order"
}];
export var mainPromo = {
  headline: "New Membership Program",
  "data-analytics-event": "Clicked Button",
  "data-analytics-label": "navigation-promo-control-membership",
  product: {
    slug: "control-membership",
    label: "Choose the test you want for just $24.99 a month.",
    url: "/control-membership/",
    tags: [],
    image: {
      alt: "Control – Proactive Health Membership",
      src: membershipControlPromoImage
    }
  }
};
export var promoCards = [{
  headline: "Current Sexual Health Membership",
  "data-analytics-event": "Clicked Button",
  "data-analytics-label": "navigation-promo-current-membership",
  product: {
    slug: "current-membership",
    label: "Proactive sexual health testing for only $14.99 a month.",
    url: "/current-membership/",
    tags: [Tag.SexualHealth],
    image: {
      alt: "Current – Sexual Health Membership",
      src: membershipCurrentPromoImage
    }
  }
}];
export var combinedProducts = [].concat(productLinks, productCards);